import CircleProgressBar from 'components/CircleProgressBar';
import { Icon } from 'components/Icon';
import React from 'react';
import { Link } from 'react-router-dom';

type Props = {
  progress: number;
  icon: any;
  name: string;
  totalAccount: number;
  totalBeneficiary: number;
  pageUrl: string;
  showAssign?: boolean;
};

export default function StatCard({
  progress,
  icon,
  name,
  totalAccount,
  totalBeneficiary,
  pageUrl,
  showAssign = true
}: Readonly<Props>) {
  return (
    <div className="flex w-72 shrink-0 rounded-md bg-white p-3">
      <div className="shrink-0">
        <button
          type="button"
          className="relative inline-flex items-center rounded-full border border-[#0B51844D] bg-[#EAEDFA] p-2 text-center"
        >
          <Icon name={icon} />
        </button>
      </div>
      <div className="ml-4">
        <h5 className="mb-2 text-sm font-bold tracking-tight text-[#353535]">
          {name}
        </h5>
        <p className="text-xs font-normal text-[#A5A5A5]">
          {totalAccount} {name}
        </p>
        <p className="text-xs font-normal text-[#A5A5A5]">
          {totalBeneficiary} Beneficiaries
        </p>
        <div className="flex items-center gap-2">
          <CircleProgressBar progress={progress} />
          <p className="my-2 text-xs font-normal text-[#A5A5A5]">
            {progress}% Assigned
          </p>
        </div>
        {showAssign && (
          <Link to={pageUrl}>
            <button
              type="button"
              className="rounded bg-primary-900 px-3 py-2 text-center text-xs font-medium text-white md:w-[10rem] md:px-5 md:py-2.5 md:text-xs"
            >
              Assign Beneficiary
            </button>
          </Link>
        )}
      </div>
    </div>
  );
}
